import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, forkJoin, map } from 'rxjs';
import { IndustryOption, DisciplineOption, MaterialOption, CountryInfo } from '../models/space.model';

@Injectable({
  providedIn: 'root'
})
export class SpaceConfigOptionsService {
  private _industries: IndustryOption[] = [];
  private _disciplines: DisciplineOption[] = [];
  private _materials: MaterialOption[] = [];
  private _countries: CountryInfo[] = [];

  constructor(private readonly http: HttpClient) {}

  load(): Observable<void> {
    return forkJoin([
      this.http.get<IndustryOption[]>('assets/data/industries.json'),
      this.http.get<DisciplineOption[]>('assets/data/disciplines.json'),
      this.http.get<MaterialOption[]>('assets/data/materials.json'),
      this.http.get<CountryInfo[]>('assets/data/countries.json')
    ]).pipe(
      map(([industries, disciplines, materials, countries]) => {
        this._industries = industries;
        this._disciplines = disciplines;
        this._materials = materials;
        this._countries = countries;
      })
    );
  }

  get industries(): IndustryOption[] {
    return this._industries;
  }

  get disciplines(): DisciplineOption[] {
    return this._disciplines;
  }

  get materials(): MaterialOption[] {
    return this._materials;
  }

  get countries(): CountryInfo[] {
    return this._countries;
  }

  get countryNames(): string[] {
    return this._countries.map(c => c.name);
  }

  getCountryInfo(name: string): CountryInfo {
    return this._countries.find(c => c.name === name) ?? this._countries[0];
  }

  normalizeIndustryId(value: string): string {
    if (!value) {
      return value;
    }

    if (this._industries.some(industry => industry.id === value)) {
      return value;
    }

    const normalizedValue = value.trim().toLowerCase();
    const byName = this._industries.find(
      industry => industry.name.trim().toLowerCase() === normalizedValue
    );

    return byName?.id ?? value;
  }
}
